import { useState } from "react";
import { buscarPeriodosByIdUsuarioService } from "../../../services/buscarPeriodosByIdUsuarioService";

export const useVerificaPeriodo = () => {
  const [isLoading, setIsLoading] = useState(false);

  const verificar = async (usuarioId: number) => {
    setIsLoading(true);

    try {
      const verificarPeriodo = await buscarPeriodosByIdUsuarioService(
        usuarioId
      );

      if (verificarPeriodo.length > 0) {
        return true; // Períodos disponíveis
      } else {
        return false; // Nenhum período disponível
      }
    } catch (error) {
      console.error("Erro ao verificar interesse:", error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    verificar,
    isLoading,
  };
};
